






import { Component, Prop, Vue } from 'vue-property-decorator';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';

@Component({
	components: {
		LoadingSpinner
	}
})
export default class TwitterAuthPopup extends Vue {

	public created() {
		// hide scrollbars
		document.body.classList.add('no-scroll');

		// check if we were sent here by locust
		const fromLocust = this.$route.query.fc;

		if (!fromLocust) {
			// twitter sent us here through our callback url, set token values
			const oauth_token = this.$route.query.oauth_token;
			const oauth_verifier = this.$route.query.oauth_verifier;

			const parentWindow = parent.window.opener['twitter-setup-ref'];

			// parentWindow.zone.run(() => {
			parentWindow.component.setAuthToken(oauth_token, oauth_verifier);
			window.close();
			// });
		}
	}
}
